import clsx from 'clsx';
import { ComponentPropsWithoutRef } from 'react';
import { genderClassName } from '../../phan-he-xet-nghiem/common';
import { parseJSON } from '../../utils/FormatUtils';

type Props = ComponentPropsWithoutRef<"span"> &  {
	rowData: any;
	value: any;
}

const CellFormatter = ({ rowData, value, className, ...props }: Props) => {
	const jsonConfig = parseJSON(rowData.additionalConfiguration);
	const textColorConfig = jsonConfig?.textColor;
	const highlightRowClassName = genderClassName(rowData);

	return (
		<div
			style={{
				color: textColorConfig ?? 'var(--kt-dark)',
			}}
			className={clsx(highlightRowClassName, className)}
			{...props}
		>
			{value}
		</div>
	);
};

export default CellFormatter;
